class BESSDynamicLoader extends BESSAppBase {
    constructor(node, postLoadedFn, params = {}) {
        super();
        this.node = node;
        if(!this.node) return;
        this.loading = this.node.find('.app-dynamic-loading');

        this.url = node.data('url');
        this.params = params;
        this.log("Dynamically loading", this.url);
        $.get(this.url, this.params, function (html) {

            let contents = $(html);
            node.append(contents);
            this.loading.fadeOut().hide();
            contents.hide();
            contents.fadeIn();
            BESSAppComponent.initialiseFor(contents);
            postLoadedFn();
        }.bind(this));
    }

    reload(params, contentHandlerFn) {
        this.loading.show().fadeIn();
        $.get(this.url, params, function (html) {
            this.loading.fadeOut().hide();
            let contents = $(html);
            contentHandlerFn(contents);
        }.bind(this));
    }

    reloadAndReplace(params) {
        this.node.empty();
        this.node.append(this.loading);
        this.loading.show();
        $.get(this.url, params, function (html) {
            this.loading.fadeOut().hide();
            let contents = $(html);
            this.node.append(contents);
            contents.hide().fadeIn();
        }.bind(this));
    }
}
